import React, { useState , useEffect} from "react";
import Select from "react-select";
import { RefreshCw, Clock } from "lucide-react";
import redirectURL from "../redirectURL"
import "../../assets/css/inventorymanagement.css"
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const OrderGeneartion = () => {

  const [orderGeneartiontytype, setorderGeneartiontytype] = useState({"label":"","value":""});

  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n")

  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [selectedTime, setSelectedTime] = useState(null);

  
  const orderGeneartion = [
    { label: "Manual", value: "manual" },
    { label: "Automatic", value: "automatic" },
  ];

  const [orderConformationSweetAlert,setOderConformationSweetAlert] = useState({
    show:false,

  })

    const dropdownStyle = {
    width: "100%",
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 10,
  };

  const sectionStyle = {
    flex: 1,
    padding: 20,
    border: "1px solid #eee",
    borderRadius: 10,
    marginBottom: 20,
    background: "#fff",
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    if (basicTitle !== "Please fill all the fields"){
    localStorage.setItem('activeTab', "orderGeneration");
    window.location.reload();
    }
   }
     // Function to convert ISO string into Date object with only time portion
  const convertToTimeFormat = (isoString) => {
    const dateObj = new Date(isoString); // Convert ISO string to Date

    // Extract hours and minutes from the date object
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();

    // Create a new Date object with the current date and set the time portion
    const currentDate = new Date();
    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(0); // Set seconds to 0 if not needed

    return currentDate; // Return the new Date object with updated time
  };

  
  useEffect(() => {
    const fetchData = async () => {
          setLoadshow("show-m");
          setOverlayBlock("show-m");
      try {
        const response = await redirectURL.post("inventory/fetchConfigurations", {});
        if (response.status === 200) {
            if (response.data.data.length > 0) {
                const data = response.data.data[0].order_generation ? JSON.parse(response.data.data[0].order_generation) : {};   
                if (Object.keys(data).length > 0) { 
                  setorderGeneartiontytype(data.orderGeneartiontytype)
                  const formattedTime = convertToTimeFormat(data.selectedTime);
                  setSelectedTime(formattedTime);
              }
            }
                  setLoadshow("show-n");
                  setOverlayBlock("show-n");
        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicTitle("Something Went Wrong");
          setBasicType("warning");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicTitle("Something Went Wrong");
        setBasicType("warning");
      }
    };

    fetchData();
  }, []); // Empty dependency array to run only once when the component mounts


  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
  };

  const handleProcessConformation = async() => {
      setOderConformationSweetAlert({show:false})

      setLoadshow("show-m")
      setOverlayBlock("show-m")
      const params = {
                    screenName :"order_generation",
                    data : JSON.stringify(
                      {orderGeneartiontytype:orderGeneartiontytype,
                      selectedTime:selectedTime
                      })
          }
      const response = await redirectURL.post("inventory/saveConfigurations", params)
      if (response.status === 200){
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Configurations Successfully Saved");
              setBasicType("success");
      }
      else{
              setLoadshow("show-n");
              setOverlayBlock("show-n");
              setShow(true);
              setBasicTitle("Something Went Wrong");
              setBasicType("warning");
      }
  }
  
  const handleProcessCancel = () => {
      setOderConformationSweetAlert({show:false})
  }
  const saveConfigurations = async() => {
    setOderConformationSweetAlert({show:true})
    }

  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
      <div style={{ zIndex: "9999999" }}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                style={{ fontSize: "9px" }}
            >
            </SweetAlert>
      </div>
      <div style={{ zIndex: "9999999" }}>
          
          <SweetAlert
            show={orderConformationSweetAlert.show}
            title="Are you sure?"
            type="info"
            showCancel
            confirmBtnText="Yes"
            cancelBtnText="No"
            confirmBtnStyle={{
              backgroundColor: "#007bff",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "14px",
            }}
            cancelBtnStyle={{
              backgroundColor: "#ea5e5e",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              padding: "6px 16px",
              fontSize: "14px",
            }}
            onConfirm={handleProcessConformation}
            onCancel={handleProcessCancel}
            focusCancelBtn
          >
                Do you want to save Configurations?
          </SweetAlert>
      </div>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20, }}>
        <RefreshCw size={24} color="#f97316" style={{ marginRight: 10 }} />
        <div>
          <h2 style={{ margin: 0 }}>Order Processing Settings</h2>
        </div>
      </div>

      {/* Triggers & Allocation */}
      <div style={sectionStyle}>
          <div style={{  display: "flex", flexDirection:"column"}}>
            <div >
              <p style={{ color: "#6c757d" }}>
                Choose Order Processing Type 
              </p>
              <div style={dropdownStyle} className="col-sm-3">
                <Select
                styles={{borderRadius:"15px"}}
                    options={orderGeneartion}
                    value={orderGeneartiontytype}
                    onChange={setorderGeneartiontytype}
                    placeholder="Select Order Generation Method"
                    className="mb-3"
                  />
              </div>
            </div>
        <div>
          
        </div>
        {orderGeneartiontytype.value == "automatic"   && 
          <div>
          <p style={{ color: "#6c757d" }}>
            Select time for Auto Processing
          </p>
           <div style={dropdownStyle} className="col-sm-3">
            <DatePicker
              selected={selectedTime}
              styles={{borderRadius:"20px"}}
              onChange={(time) => setSelectedTime(time)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={60} // Time interval in minutes (default is 30)
              dateFormat="h aa" // Display format for time (12-hour format with AM/PM)
              className="form-control"
              placeholderText="Select Time"
            />
          </div>
          </div>}
      </div>


      </div>
      <div className="col-sm-12" style={{textAlign: "right", display : "flex", justifyContent: "flex-end"}}>
            <button 
                onClick={() => { saveConfigurations() }}
                style={{
                  
                  padding: "10px 20px",
                  backgroundColor: "#991548",
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 14,
                  cursor: "pointer",
                }}
                  >
                    Save All Configurations
            </button>
      </div>
    
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
        <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      ></div>
    </div>
  );
};

export default OrderGeneartion;
